module.exports = __webpack_public_path__ + "static/media/web_shuttle-ux@2x.8a776bcc.png";